import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import NumberFormat from 'react-number-format';
import Decimal from 'decimal.js';
import { MAX_LIMIT } from 'modules/common/constants';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../../../../constant';
import * as actions from '../../../../action';

function UpdateDetailsModal({
  updateDetails,
  getDetailsList,
  updateList,
  detailsId,
  newTaxRevenuesId,
  calculationsId,
  updating,
}) {
  const [formData, setFormData] = useState({
    from: '',
    to: '',
    amount: '',
    rate: '',
    for_excess_computation: 0,
  });

  const validateForm = useFormValidator(formData, {
    from: 'required|amount',
    to: 'required|amount',
    amount: 'required|amount',
    rate: 'required',
  });
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    updateDetails(newTaxRevenuesId, calculationsId, detailsId, formData, () => {
      setModal({ isOpen: false });
      getDetailsList(newTaxRevenuesId, calculationsId);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        from: _.get(updateList, 'from').toString(),
        to: _.get(updateList, 'to').toString(),
        amount: _.get(updateList, 'amount').toString(),
        rate: _.get(updateList, 'rate').toString(),
        for_excess_computation:
          _.get(updateList, 'for_excess_computation') || 0,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA_DETAILS)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, {});

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onCheck = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked ? 1 : 0,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              From: {validateForm.renderMessage('from')}
            </label>
            <input
              className="form-control"
              type="number"
              name="from"
              onChange={onChange}
              placeholder="Ex. 0.00"
              value={_.get(formData, 'from')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              To: {validateForm.renderMessage('to')}
            </label>
            <input
              className="form-control"
              type="number"
              name="to"
              onChange={onChange}
              placeholder="Ex. 0.00"
              value={_.get(formData, 'to')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Amount: {validateForm.renderMessage('amount')}
            </label>
            <NumberFormat
              name="amount"
              id="amount"
              placeholder="0.00"
              className="form-control"
              onValueChange={(values) => {
                const { value } = values;
                const prop = {
                  target: {
                    name: 'amount',
                    value,
                  },
                };
                onChange(prop);
              }}
              displayType="input"
              decimalScale={2}
              isNumericString
              allowNegative
              thousandSeparator
              allowLeadingZeros
              prefix="₱ "
              value={_.get(formData, 'amount')}
              isAllowed={(values) => {
                const { value } = values;
                if (!value) return true;
                const val = new Decimal(value);
                const max = new Decimal(MAX_LIMIT);
                return value === undefined || val.lte(max);
              }}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Rate: {validateForm.renderMessage('rate')}
            </label>
            <input
              className="form-control"
              type="number"
              name="rate"
              onChange={onChange}
              placeholder="Ex. 0.123456"
              value={_.get(formData, 'rate')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label">For Excess Computation: &nbsp;</label>
            <input
              name="for_excess_computation"
              type="checkbox"
              checked={_.get(formData, 'for_excess_computation')}
              onChange={onCheck}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateDetailsModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateDetails: PropTypes.instanceOf(Function).isRequired,
  getDetailsList: PropTypes.instanceOf(Function).isRequired,
  detailsId: PropTypes.string.isRequired,
  newTaxRevenuesId: PropTypes.string.isRequired,
  calculationsId: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_DETAILS_PERMIT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateDetailsModal);
